"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { Camera, Images, Trophy } from "lucide-react"

const COMMUNITY_LINKS = [
  { href: "/community", label: "Gallery", icon: Images },
  { href: "/community/leaderboard", label: "Leaderboard", icon: Trophy },
  { href: "/community/submit", label: "Share your lawn", icon: Camera },
] as const

export function CommunityNav() {
  const pathname = usePathname()

  return (
    <div className="border-b border-green-950/10 bg-[#f5f8f2]">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
        <Link
          href="/community"
          className="font-editorial hidden text-lg font-semibold text-green-950 transition-colors hover:text-green-700 sm:block"
        >
          The Lawn Gallery
        </Link>

        <nav aria-label="Community" className="scroll-hint-fade scroll-hint-fade-sm-only -mx-1 flex w-full items-center gap-1 overflow-x-auto px-1 sm:mx-0 sm:w-auto sm:overflow-visible sm:px-0">
          {COMMUNITY_LINKS.map(({ href, label, icon: Icon }) => {
            const isActive = href === "/community"
              ? pathname === href || (pathname.startsWith("/community/") && !pathname.startsWith("/community/leaderboard") && !pathname.startsWith("/community/submit"))
              : pathname.startsWith(href)

            return (
              <Link
                key={href}
                href={href}
                aria-label={label}
                aria-current={isActive ? "page" : undefined}
                className={`inline-flex min-h-11 shrink-0 items-center gap-2 rounded-full px-3.5 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-600 focus-visible:ring-offset-2 ${
                  isActive
                    ? "bg-green-950 text-white"
                    : href === "/community/submit"
                      ? "bg-green-600 text-white hover:bg-green-700"
                      : "text-green-900 hover:bg-green-100"
                }`}
              >
                <Icon className="h-4 w-4" aria-hidden="true" />
                {href === "/community/submit" ? (
                  <>
                    <span className="sm:hidden">Share</span>
                    <span className="hidden sm:inline">{label}</span>
                  </>
                ) : label}
              </Link>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
